import { createContext } from 'react';

const CoreConfigContext = createContext({});

export default CoreConfigContext;
